import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';



import { CalendarModule } from "ion2-calendar";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { AppVersion } from '@ionic-native/app-version';

import { MyApp } from './app.component';
import { MediwareHubService } from '../providers/mediware-hub/mediware-hub';
import { ComponentsModule } from '../components/components.module';
import { NavMenuProvider } from '../providers/nav-menu/nav-menu';
import { SessionProvider } from '../providers/session/session';
import { LoadingProvider } from '../providers/loading/loading';
import { MediwareHubInterceptor } from '../providers/mediware-hub-interceptor/mediware-hub-interceptor';
import { SalaEsperaProvider } from '../providers/sala-espera/sala-espera';
import { NovedadesProvider } from '../providers/novedades/novedades';
import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';

import { Chooser } from '@ionic-native/chooser';
import { Camera } from '@ionic-native/camera';

import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { FileOpener } from '@ionic-native/file-opener';

import { IonicImageViewerModule } from 'ionic-img-viewer';
/*
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
registerLocaleData(localeAr);*/
import { ClipboardModule } from 'ngx-clipboard';
import { SpeechRecognition } from '@ionic-native/speech-recognition/ngx';

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    IonicModule.forRoot(MyApp, {
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
                   'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ],
      monthShortNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago',
                        'Sep', 'Oct', 'Nov', 'Dic' ],
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves',
                 'Viernes', 'Sábado' ],
      dayShortNames: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb' ] }),
    BrowserModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    PipesModule,
    ComponentsModule,
    CalendarModule,
    DirectivesModule,
    IonicImageViewerModule,
    ClipboardModule,
    ReactiveFormsModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Añadir esto si estás usando Web Components

  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    //{ provide: LOCALE_ID, useValue: 'es-AR' },
    MediwareHubService,
    NavMenuProvider,
    SessionProvider,
    LoadingProvider,
    SalaEsperaProvider,
    NovedadesProvider,
    Chooser,
    Camera,
    File,
    FileTransfer,
    FileOpener,
    AppVersion,
    SpeechRecognition,
    { provide: HTTP_INTERCEPTORS, useClass: MediwareHubInterceptor, multi: true }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts